import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { H1, NotificationItem, Text, CenteredLayout, BoldText } from '../../../components';
import { ReactComponent as Logo } from '../../../assets/images/logo.svg';

import { useUsers } from '../../organization';

const StyledH1 = styled(H1)`
  margin: 16px auto 40px;
`;

const StyledCenteredLayout = styled(CenteredLayout)`
  background-color: var(--background-light);
`;

const Invitations = () => {
  const { invitations, acceptInvitation, declineInvitation } = useUsers();
  const navigate = useNavigate();

  const handleAccept = async (invitation) => {
    await acceptInvitation(invitation);
    navigate('/spaces');
  };

  const handleDecline = useCallback(
    async (invitation) => {
      await declineInvitation(invitation);
      if (invitations.length === 1) {
        navigate('/onboarding/organization');
      }
    },
    [invitations]
  );

  return (
    <StyledCenteredLayout>
      <Logo width={96} height={96} />
      <StyledH1>Accept invitations</StyledH1>
      {(invitations.length &&
        invitations.map((invitation) => (
          <NotificationItem
            key={invitation.id}
            initiator={invitation?.creator?.name}
            title={
              <>
                <BoldText text={invitation?.creator?.name} /> invited you to{' '}
                <BoldText text={invitation?.organization.name} />
              </>
            }
            picture={invitation?.creator?.picture}
            onAccept={() => handleAccept(invitation)}
            onDecline={() => handleDecline(invitation)}
            acceptLabel='Accept'
            declineLabel='Decline'
            small
          />
        ))) || <Text>You don&apos;t have pending invitations</Text>}
    </StyledCenteredLayout>
  );
};

export { Invitations };
